(function() {
  'use strict';

  var KLAVIYO_PUBLIC_KEY = 'SbKUWL';
  var KLAVIYO_NEWSLETTER_LIST_ID = 'YmUnPY';
  var KLAVIYO_REVISION = '2024-10-15';

  // ---- DOM refs ----
  var overlay = document.getElementById('bis-overlay');
  var closeBtn = document.getElementById('bis-close');
  var formView = document.getElementById('bis-form-view');
  var successView = document.getElementById('bis-success-view');
  var emailInput = document.getElementById('bis-email');
  var errorEl = document.getElementById('bis-error');
  var submitBtn = document.getElementById('bis-submit');
  var submitLabel = submitBtn ? submitBtn.querySelector('span') : null;
  var consentCheckbox = document.getElementById('bis-consent');
  var honeypot = document.getElementById('bis-hp');

  if (!overlay) return;

  // ---- Klaviyo POST helper ----
  function klaviyoPost(endpoint, payload, contentType) {
    return fetch('https://a.klaviyo.com' + endpoint + '?company_id=' + KLAVIYO_PUBLIC_KEY, {
      method: 'POST',
      headers: {
        'Content-Type': contentType || 'application/json',
        'revision': KLAVIYO_REVISION
      },
      body: JSON.stringify(payload)
    }).then(function(res) {
      if (!res.ok) throw new Error('Klaviyo ' + endpoint + ' responded ' + res.status);
      return res;
    });
  }

  // ---- Modal open/close ----
  function openModal() {
    // Reset to form view
    formView.style.display = '';
    successView.style.display = 'none';
    emailInput.value = '';
    errorEl.style.display = 'none';
    submitBtn.disabled = false;
    if (submitLabel) submitLabel.textContent = 'Notify me';
    if (consentCheckbox) consentCheckbox.checked = false;

    overlay.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    setTimeout(function() {
      overlay.classList.add('bis-overlay--active');
    }, 10);
  }

  function closeModal() {
    overlay.classList.remove('bis-overlay--active');
    setTimeout(function() {
      overlay.style.display = 'none';
      document.body.style.overflow = '';
    }, 300);
  }

  // ---- Bind open triggers (delegate for dynamic content) ----
  document.addEventListener('click', function(e) {
    if (e.target.closest('.bis-open-button')) {
      openModal();
    }
  });

  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) closeModal();
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay.style.display === 'flex') closeModal();
  });

  // ---- Get current variant ID from notify-button data attribute ----
  function getVariantId() {
    var notifyBtn = document.querySelector('.notify-button[data-variant-id]');
    return notifyBtn ? notifyBtn.dataset.variantId : '';
  }

  // ---- Form submit ----
  submitBtn.addEventListener('click', function(e) {
    e.preventDefault();

    // Honeypot check
    if (honeypot && honeypot.value !== '') return;

    // Email validation
    var email = emailInput.value.trim();
    if (!email) {
      errorEl.textContent = 'Please enter your email address.';
      errorEl.style.display = 'block';
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errorEl.textContent = 'Please enter a valid email address.';
      errorEl.style.display = 'block';
      return;
    }

    errorEl.style.display = 'none';
    submitBtn.disabled = true;
    if (submitLabel) submitLabel.textContent = 'Sending\u2026';

    var variantId = getVariantId();

    // Step 1: Back in Stock subscription
    var bisPayload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email
              }
            }
          }
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + variantId
            }
          }
        }
      }
    };

    klaviyoPost('/client/back-in-stock-subscriptions/', bisPayload)
      .then(function() {
        // Step 2: Newsletter subscription if consent checked
        if (consentCheckbox && consentCheckbox.checked) {
          return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_PUBLIC_KEY, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/vnd.api+json',
              'revision': KLAVIYO_REVISION
            },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: 'Back in Stock modal',
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: {
                        email: email
                      }
                    }
                  }
                },
                relationships: {
                  list: {
                    data: {
                      type: 'list',
                      id: KLAVIYO_NEWSLETTER_LIST_ID
                    }
                  }
                }
              }
            })
          }).catch(function(err) { console.warn('Subscription failed (non-blocking):', err); });
        }
      })
      .then(function() {
        // Success state
        formView.style.display = 'none';
        successView.style.display = 'block';

        // Auto-dismiss after 4s
        setTimeout(function() {
          closeModal();
        }, 4000);
      })
      .catch(function() {
        // Fail-open: show error, let user retry
        errorEl.textContent = 'Something went wrong. Please try again.';
        errorEl.style.display = 'block';
        submitBtn.disabled = false;
        if (submitLabel) submitLabel.textContent = 'Notify me';
      });
  });
})();
